export class FindingExclusionDetectorFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<FindingExclusionDetectorType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<FindingExclusionDetectorType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionDetectorFilters.attributeTypeMap;
    }
    constructor() {
    }
}
